import protobuf from 'protobufjs'
import { WS_ROOM_PROTOBUF_JSON } from './wsEnvelopeJson.js'

let cached = null

/**
 * 房间页共用的 chat protobuf 类型（单例缓存）
 */
export function getRoomProtobufTypes () {
  if (cached) return cached
  const root = protobuf.Root.fromJSON(WS_ROOM_PROTOBUF_JSON)
  cached = {
    ChatMessage: root.lookupType('chat.ChatMessage'),
    WsEnvelope: root.lookupType('chat.WsEnvelope'),
    AudioChunk: root.lookupType('chat.AudioChunk')
  }
  if (!cached.ChatMessage || !cached.WsEnvelope || !cached.AudioChunk) {
    throw new Error('Failed to lookup protobuf types')
  }
  return cached
}
